
import { Component, Vue } from "vue-property-decorator";
import SvgIcon from "@jamescoyle/vue-icon";
import CustomChipLink from "@/components/CustomChipLink.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import { Getter } from "vuex-class";
import EditBuilding from "@/components/buildings/EditBuilding.vue";
import { mdiDoorOpen, mdiFormatListBulletedType, mdiKey, mdiNoteText, mdiPackageVariant } from "@mdi/js";
import { getMapLink } from "@/utils/misc";
import { mdiMapMarkerRadiusOutline } from "@mdi/js";

const septeoImage = require("@/assets/images/septeo.png");
const urmetImage = require("@/assets/images/urmet.png");

@Component({
  components: {
    EditBuilding,
    KeyStatus,
    CustomChipLink,
    SvgIcon,
  },
})
export default class Building extends Vue {

  @Getter private canDoInEnvCompany: (right: string, companyId?: number) => boolean;
  @Getter private envCompanyId: number | null;
  @Getter private envCompany: any;
  @Getter private isAdmin: boolean;

  private buildingId: number | null = null;
  private subTab: string = null;
  private loadingSubTab: boolean = false;
  private building: any = {};
  private loadingGetBuilding: boolean = false;
  private septeoGroup: any | null = null;
  private mapLink = getMapLink;
  private mdiMapMarkerRadiusOutline: any = mdiMapMarkerRadiusOutline;

  private septeoImage = septeoImage;
  private urmetImage = urmetImage;
  private icons = {
    mdiDoorOpen,
    mdiFormatListBulletedType,
    mdiKey,
    mdiNoteText,
    mdiPackageVariant,
  };

  get displayBoxes(): boolean {
    return true;
  }

  get displayBuildingKeys(): boolean {
    return !this.building?.Relays?.length;
  }

  get displayMissionOrders(): boolean {
    return !this.building?.Relays?.length && this.canDoInEnvCompany("MANAGE_MISSION_ORDERS");
  }

  /**
   * Performs necessary operations when the component is mounted.
   *
   * @private
   * @memberof ComponentName
   *
   * @returns {void}
   */
  private mounted() {
    this.buildingId = Number(this.$route.params?.id);
    this.getBuildBingById().then(
      () => {
        // Only for user accessing root page, not specific tabs
        if (this.$route.name === "building") {
          if (!this.displayBuildingKeys) {
            this.$router.replace({ name: "building-equipments" });
          } else {
            this.$router.replace({ name: "building-keys" });
          }
        }
      },
    );
    if (this.canDoInEnvCompany("READ_BUILDING")) {
      this.getSepteoGroupByBuildingId();
    }
  }

  private onChangeTab($event) {
    this.loadingSubTab = true;
  }

  /**
   * Retrieves the Bing building data by the given building ID.
   *
   * @returns {Promise} A promise that resolves to the building data.
   */
  private getBuildBingById() {
    this.loadingGetBuilding = true;
    return this.$store.dispatch("buildings/getBuildingById", {
      buildingId: this.buildingId,
    })
      .then((data) => {
        this.building = data;
      })
      .catch((error) => {
        this.$store.commit("alerts/displayHttpError", { error });
      })
      .finally(() => { this.loadingGetBuilding = false; });
  }

  /**
   * Get the septeo group by building ID.
   *
   * @private
   * @returns {Promise} A promise that resolves to the septeo group data.
   */
  private getSepteoGroupByBuildingId() {
    return this.$store.dispatch("buildings/getSepteoGroupByBuildingId", {
      buildingId: this.buildingId,
    })
      .then((data) => {
        this.septeoGroup = data;
      });
  }

}
